const LayoutPlayground = {
    prefix: 'flex',

    init() {
        this.el = $('[template="Sitelab"] [container="playground"][content="Grid"]');
        if (!this.el.length) return;

        this.form = this.el.find('form');
        this.game = this.el.find('[block="preview"] #game');
        this.results = this.el.find('.result');
        this.bind();
    },

    bind() {
        this.form.find('input[type]').change((evt) => {
            this.set();
        })

        this.form.find('select').change((evt) => {
            this.set();
        })
    },

    set() {
        const direction = this.form.find('#direction').val();
        const align = this.form.find('#align').val();
        const valign = this.form.find('#valign').val();

        const value = direction + align + valign;
        this.form.attr('direction', direction);
        this.setFeatures(value);
    },

    setFeatures(value) {
        const wrap = this.form.find('#wrap').prop('checked');
        const reverse = this.form.find('#reverse').prop('checked');

        const result = {};
        result.plain = this.prefix + value + (wrap ? ' wrap' : '') + (reverse ? ' reverse' : '');
        result.mixin = '.' + this.prefix + value + (wrap ? ' .wrap;' : '') + (reverse ? ' .reverse;' : '');
        result.attribute = 'flex="' + value.toLowerCase() + '"'
        result.class = 'class="' + this.prefix + value + (wrap ? ' wrap' : '') + (reverse ? ' reverse' : '');

        this.game.removeAttr('class').addClass(result.plain);
        this.print(result);

    },

    print(result) {
        let items = Object.entries(result);
        items.forEach((el, i) => {
            this.results.find('.' + el[0]).text(el[1]);
        })
    }
}

export default LayoutPlayground;